import { useIntl } from '@/intl'
import { FilterableCarsAvailable } from '@/scopes/checkout/components/services/CarRentalFilteringService/FilterableCars/FilterableCarsAvailable'
import {
  showingFilterableCars,
  useCarRentalServiceStore,
} from '@/scopes/checkout/components/services/CarRentalFilteringService/store'
import { createCarEvent } from '@/scopes/checkout/domain/analytics'
import { useService } from '@/scopes/checkout/domain/hooks'
import { ServiceType } from '@/scopes/checkout/domain/types'
import { useAnalytics } from '@/scopes/common/infrastructure/analytics/hooks'
import { Button, Sheet } from '@sunwebgroup/ui-components/uds'
import * as React from 'react'

export function RentalCarListerView() {
  const { service } = useService(ServiceType.CarRentalFiltering)
  const intl = useIntl()
  const { sendEvent } = useAnalytics()
  const { setShowFilterableCars } = useCarRentalServiceStore()
  const isShowingFilterableCars = useCarRentalServiceStore(showingFilterableCars)

  const handleOpenChange = (isOpen: boolean) => {
    setShowFilterableCars(isOpen)
    if (isOpen) {
      sendEvent(
        createCarEvent({
          result: 'Show all available cars',
          description: 'Filterable cars sheet opened',
          element: 'bottom sheet',
          validated: true,
        }),
      )
    }
    else {
      sendEvent(
        createCarEvent({
          result: 'Hide all available cars',
          description: 'Filterable cars sheet closed',
          element: 'bottom sheet',
          validated: true,
        }),
      )
    }
  }

  if (!service)
    return null

  return (
    <Sheet.Root
      open={isShowingFilterableCars}
      onOpenChange={(open) => {
        handleOpenChange(open)
      }}
    >
      <Sheet.Trigger>
        <Button $type="secondary" $fullWidth onClick={() => handleOpenChange(true)}>{intl.formatMessage({ id: 'checkout_steps_ancillaries_car_rental_filtering_show_all_action' })}</Button>
      </Sheet.Trigger>

      <Sheet.Body side="bottom" hasPadding={false}>
        <Sheet.Header closeLabel={intl.formatMessage({ id: 'checkout_steps_ancillaries_car_rental_filtering_all_cars_close_text' })} titleLabel={intl.formatMessage({ id: 'checkout_steps_ancillaries_car_rental_filtering_all_cars_title' })} />
        <FilterableCarsAvailable />
      </Sheet.Body>
    </Sheet.Root>
  )
}
